import React from 'react'
import Headline from '../atoms/Headline'
import Link from '../atoms/Link'
import Image from '../atoms/Image'

import { useTranslation } from 'react-i18next'
import SbEditable from 'storyblok-react'

const DownloadsBlock = ({ block }) => {
  const formatExtension = (extension) => {
    let formatedExtention = extension.replace('.', '').toUpperCase()
    return formatedExtention
  }
  const { t } = useTranslation()

  return (
    <SbEditable content={block}>
      <section className="downloads-block">
        <div className="downloads-block-container">
          <div className="downloads-block-wrapper">
            <div className="downloads-block-row">
              <div
                data-rellax-center={true}
                data-rellax-speed={-1}
                className="downloads-block-cell downloads-block-leftcell"
              >
                {block.catalog?.length > 0 && (
                  <>
                    <Headline
                      headline={block.catalogue_title}
                      subheadline={block.catalogue_subtitle}
                      kicker={block.catalogue_kicker}
                    />
                    {block.catalog?.length === 1 ? (
                      <Link
                        link={block.catalog[0].original_url}
                        target="_blank"
                        className="downloads-block-catalogue"
                        id="data-download"
                      >
                        <Image
                          className="img-fluid"
                          image={block.catalog[0].preview_url}
                        />
                      </Link>
                    ) : (
                      <ul className="downloads-block-catalogues download-list">
                        {block.catalog?.map((item, index) => (
                          <li key={index}>
                            <Link
                              link={item.original_url}
                              target="_blank"
                              id="data-download"
                            >
                              <Image
                                className="img-fluid"
                                image={item.preview_url}
                              />
                              <div>
                                {item.title}
                                <small>{formatExtension(item.extension)}</small>
                              </div>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                )}
              </div>
              <div
                data-rellax-center={true}
                data-rellax-speed={1}
                className="downloads-block-cell downloads-block-rightcell"
              >
                <div className="downloads-block-rightcell-wrapper">
                  {block.product_downloads?.length > 0 && (
                    <>
                      <Headline headline={block.downloads_title} />
                      <ul className="downloads-block-downloads download-list">
                        {block.product_downloads?.map((item, index) => (
                          <li key={index}>
                            <Link
                              link={item.original_url}
                              target="_blank"
                              id="data-download"
                            >
                              {item.title}
                              <small>{formatExtension(item.extension)}</small>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </>
                  )}
                  {block.certificates?.length > 0 && (
                    <>
                      <Headline headline={block.certificates_title} />
                      <ul className="downloads-block-certificates download-list">
                        {block.certificates?.map((item, index) => (
                          <li key={index}>
                            <Link
                              link={item.original_url}
                              target="_blank"
                              id="data-download"
                            >
                              {item.title}
                              <small>{formatExtension(item.extension)}</small>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </>
                  )}
                  <a
                    className="btn btn-primary"
                    href={`${
                      t('product_page.downloads_block.media_db_path') +
                      block.category_hash
                    }`}
                    target="_blank"
                  >
                    {t('product_page.downloads_block.all_downloads')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default DownloadsBlock
